import {
  dateOfBirth,
  emailAddress,
  firstName,
  insuranceProvider,
  lastName,
  phoneNumber,
  preferredLocale,
  shippingAddress,
} from "@/schemas/zod-schemas"
import { supportalTimeZones } from "@/utils/timezoneOptions"
import { z } from "zod"

export const formSchema = z.object({
  firstName: z
    .string()
    .nonempty("First name is a required field")
    .pipe(firstName),
  lastName: z.string().nonempty("Last name is a required field").pipe(lastName),
  emailAddress: emailAddress.or(z.literal("")).optional(),
  phoneNumber: z
    .string()
    .nonempty("Phone number is a required field")
    .pipe(phoneNumber),
  dateOfBirth: dateOfBirth.or(z.literal("")).optional(),
  preferredLocale: preferredLocale.or(z.literal("")).optional(),
  timeZone: z
    .string()
    .nonempty("Time zone is a required field")
    .pipe(z.enum(supportalTimeZones)),
  shippingAddress: shippingAddress.optional(),
  insuranceProvider: insuranceProvider.or(z.literal("")).optional(),
  isAttCompatible: z.boolean().optional()
})
